import './App.css';
import {
    Box,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {StyledTableRow} from "./TableUtils";

function SectorsTable({data, loading = false}) {
    /*
    const [data, setData] = useState([]);

    const loadData = async () => {
        const response = await fetch(`http://localhost:8091/api/v1/ticket/dashboard/sector?groups=${groups}`);
        setData(await response.json());
    }

    useEffect(() => {
        loadData()
    }, [])
    */

    return (<TableContainer component={Paper}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{fontSize: 18, fontWeight: 'bold'}}>Time</TableCell>
                        <TableCell sx={{fontSize: 18, fontWeight: 'bold', textAlign: 'center', color: 'blue'}}>Total
                            aberto HOJE</TableCell>
                        <TableCell sx={{
                            fontSize: 18,
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: 'red'
                        }}>Total vencido HOJE</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!loading && data.map((item, index) => (
                        <StyledTableRow key={item.sector_id}>
                            <TableCell
                                sx={{fontSize: 18, fontWeight: 'bold'}}>{item.description}</TableCell>
                            <TableCell sx={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}>{item.total_aberto}</TableCell>
                            <TableCell sx={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}>{item.total_vencido}</TableCell>
                        </StyledTableRow>
                    ))}
                    {loading && <TableRow>
                        <TableCell colSpan={3} sx={{textAlign: "center"}}>
                            <Box sx={{m: 1}}><CircularProgress size={20}/></Box>
                        </TableCell>
                    </TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SectorsTable;
